import "./index.css"
import "./mobile.css"
import React, {useEffect,useRef} from 'react';
import { TypeAnimation } from 'react-type-animation';

function LiveChat(props) {
  const opener = props.opener;
  const messages = props.messages;
  const typingState = props.typingGif;
  const liveChatRef = useRef(null);

  useEffect(() => {
    // Scroll to the top of the last message when messages change
    if (liveChatRef.current&&messages.length>1) {
      const lastMessage = liveChatRef.current.querySelector(".message-container:last-child");
      if (lastMessage) {
        lastMessage.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [messages]);
  
  const messageElements = messages.map((message, index) => {
    if (message.role === "user") {
      return (
        <div key={index} className="user-message message-container">
          <div className="message">{message.content}</div>
          <img className="user-message-image" src="./icons/user-icon.png" alt="Default user icon" />
        </div>
      );
    } else if (message.role === "assistant") {
      return (
        <div key={index} className="matt-message message-container">
          <img className="matt-message-image" src="./icons/matt-icon.png" alt="Small memoji of Matt Bristow" />
          <div className="message">{message.content}</div>
        </div>
      );
    }
    return null; // Handle other cases or errors if necessary
  });
  messageElements.unshift((
    <div className="matt-message message-container">
      <img className="matt-message-image" src="./icons/matt-icon.png" alt="Small memoji of Matt Bristow" />
      <div className="message">{opener}</div>
    </div>
  ))
  if(typingState===true){
    messageElements.push((
      <div className="matt-message message-container">
      <img className="matt-message-image" src="./icons/matt-icon.png" alt="Small memoji of Matt Bristow" />
      <div className="message" id="typing-gif">
      <TypeAnimation
      sequence={[
        '.',
        500,
        '..',
        500,
        '...',
        500,
      ]}
      omitDeletionAnimation={true}
      speed={1}
      repeat={Infinity}
      cursor={false}
    /></div>
    </div>
    ))
  }
  return (
    <div id="live-chat" ref={liveChatRef}>
      {messageElements}
    </div>
  );
}

export default LiveChat;
